import React from 'react'

const DotsLoader = () => {
  return (
    <div className='takaful--dots-loader'></div>
  )
}

export default DotsLoader